export default {"src":"/_next/static/media/bell-success.fcd033e3.svg","height":19,"width":17,"blurWidth":0,"blurHeight":0};